import { z } from 'zod';

import { createUserFeatureFlagsSchema } from '../validations';

export const zodUpdateUserSettingsAdminEndpointSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('user'),
  z.uuid(),
  z.literal('settings'),
]);

/**
 * Resetting a read path to inherit sends an explicit `null`. The Assistant override only
 * takes a boolean: `null` would disable it, not inherit. Every key outside the user feature
 * flags is stripped, so a request never overwrites settings the admin app does not model.
 */
export const zodUpdateUserSettingsAdminPayloadSchema = z.object({
  featureFlags: createUserFeatureFlagsSchema({
    assistant: z.boolean().optional(),
    boolean: z.boolean().optional(),
    readPath: z.boolean().nullish(),
  }),
});
